import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  Alert,
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import './ForgotPassword.css';

function ForgotPassword() {
  const navigate = useNavigate();
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      setError('');
      setMessage('');
      setLoading(true);
      await resetPassword(email);
      setMessage('Check your inbox for password reset instructions');
    } catch (error) {
      setError('Failed to reset password: ' + error.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Container maxWidth={false} className="forgot-password-container">
      <Paper elevation={0} className="forgot-password-card">
        <Typography variant="h5" className="forgot-password-title">
          Reset Password
        </Typography>

        {error && (
          <Alert severity="error" className="forgot-password-alert">
            {error}
          </Alert>
        )}

        {message && (
          <Alert severity="success" className="forgot-password-alert">
            {message}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            variant="outlined"
            required
            autoFocus
            autoComplete="email"
          />
          <Button
            type="submit"
            variant="contained"
            disabled={loading}
            className="login-button"
          >
            Reset Password
          </Button>
        </form>

        <Box className="login-footer">
          <Typography variant="body2">
            Remember your password?{' '}
            <Link to="/login" className="login-link">
              Sign In
            </Link>
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default ForgotPassword;
